import React from 'react';
import styled from 'styled-components';
import { string, object, number, bool } from 'prop-types';
import Wrapper from '../Wrapper';
import { CaptionText } from '../Text/Heading';
import useWindowSize from '../../utils/windowSize';

const TagWrapper = styled(Wrapper)`
  display: flex;
`;

const PillWrapper = styled(Wrapper)`
  ${({ type }) => {
    if (type === 2) return `border-radius: 0;`;
    return `border-radius: 40px;`;
  }}
  box-sizing: border-box;
  word-break: break-all;
  padding: 4px 8px;
  max-width: 130px;
  display: inline-block;
`;

const LeftArrow = styled(Wrapper)`
  width: 0;
  border-top: 12px solid
    ${({ theme, borderColor }) => theme.colors[borderColor]};
  border-bottom: 12px solid
    ${({ theme, borderColor }) => theme.colors[borderColor]};
  border-right: 12px solid transparent;
`;

const PillText = props => (
  <CaptionText
    lineHeight="16px"
    numberOfLines={1}
    ellipsizeMode="tail"
    {...props}
  />
);

const Tag = ({
  children,
  wrapperStyles,
  textStyles,
  type = 1,
  backgroundColor = 'primary',
  override,
}) => {
  const { isMobileView } = useWindowSize();

  const getBackgroundColor = () => {
    return override ? (isMobileView ? '#DC3224' : '#ffffff') : backgroundColor;
  };
  return (
    <TagWrapper {...wrapperStyles}>
      <PillWrapper type={type} backgroundColor={getBackgroundColor()}>
        <PillText color="primaryWhite" {...textStyles} override={override}>
          {children}
        </PillText>
      </PillWrapper>
      {type === 2 && <LeftArrow borderColor={backgroundColor} />}
    </TagWrapper>
  );
};

Tag.defaultProps = {
  wrapperStyles: {},
  textStyles: {},
  override: false,
};

Tag.propTypes = {
  type: number,
  backgroundColor: string,
  children: string.isRequired,
  wrapperStyles: object,
  textStyles: object,
  override: bool,
};

export default Tag;
